function waitForElement(selector, callback, count = 1, countLimit = 30) {
	const checkWaitingElementInterval = setInterval(() => {
		if (document.querySelectorAll(selector).length >= count) {
			clearInterval(checkWaitingElementInterval)
			callback();
		} else {
			countLimit--
		}

		if (!countLimit) {
			clearInterval(checkWaitingElementInterval)
			if (document.querySelectorAll(selector).length > 0) callback();
		}
	}, 1000);
}

class VariantQuantity extends HTMLElement {
  constructor() {
    super();

    this.radioInput = this.querySelector('.js-variant-quantity')
    this.section = this.closest('.shopify-section')
  }

  connectedCallback () {
    this.radioInput.addEventListener('input', this.handleSelection.bind(this))

    if (+this.radioInput.dataset.quantity === 2) {
      waitForElement('.appstle_sub_widget', () => {
        this.radioInput.click()
      })

    }

    // Dawn's product-info.js resets the quantity to 1 after every cart update
    // (quantityUpdate), so a second add of "20 lbs" sent 1 bag. Put the
    // selected size's bag count back.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
        if (this.radioInput.checked) this.applyQuantity(this.radioInput.dataset.quantity)
      })
    }

    // Switching One Time / Subscribe makes Appstle redraw its prices from the
    // page's base variant (5 lb, $49.95), so put the selected size's prices back.
    if (this.section && 'MutationObserver' in window) {
      let pending = false
      this.priceObserver = new MutationObserver(() => {
        if (pending || !this.radioInput.checked) return
        pending = true
        setTimeout(() => {
          pending = false
          if (this.radioInput.checked) this.updatePrices(this.radioInput.dataset)
        }, 0)
      })
      this.priceObserver.observe(this.section, { childList: true, characterData: true, subtree: true })
    }
  }

  disconnectedCallback () {
    this.radioInput.removeEventListener('input')
    if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber()
    if (this.priceObserver) this.priceObserver.disconnect()
  }

  setHtml (selector, html) {
    // Only write when different, so the price observer doesn't loop on its own writes
    this.section.querySelectorAll(selector).forEach(el => {
      if (el.innerHTML !== html) el.innerHTML = html
    })
  }

  updatePrices ({ quantity, price }) {
    const totalPrice = Number(quantity) * Number(price)
    // Shopify takes 10% off each bag, rounded to the cent, then multiplies
    const subPrice = Number(quantity) * Math.round(Number(price) * 0.9)
    const oneTime = this.section.querySelector('.appstle_one_time_details_wrapper input[type="radio"]')
    const subscribed = oneTime ? !oneTime.checked : false

    this.setHtml('.price-item--regular:not(.appstle_subscription_final_price)', `${Shopify.formatMoney(totalPrice)} USD`)
    this.setHtml('.appstle_subscription_final_price', `${Shopify.formatMoney(subscribed ? subPrice : totalPrice)}${subscribed ? '' : ' USD'}`)
    this.setHtml('.appstle_one_time_price_wrapper .appstle_subscription_amount', `${Shopify.formatMoney(totalPrice)}`)
    this.setHtml('.appstle_subscription_amount_wrapper .appstle_subscription_compare_amount', `${Shopify.formatMoney(totalPrice)}`)
    this.setHtml('.appstle_subscription_amount_wrapper .appstle_subscription_amount', `${Shopify.formatMoney(subPrice)}`)
    this.setHtml('.appstle_select .transcy-money', `${Shopify.formatMoney(subPrice)}`)
  }

  applyQuantity (quantity) {
    this.section.querySelectorAll('[name="quantity"]').forEach(el => el.value = quantity)
    const salesUnit = this.section.querySelector('.js-sales-unit')
    if (salesUnit) salesUnit.value = quantity
  }

  handleSelection (event) {
    const { quantity, note, fulfillmentCount } = event.target.dataset

    this.updatePrices(event.target.dataset)

    this.section.querySelectorAll('[name="id"]').forEach(el => el.value = event.target.value)
    this.applyQuantity(quantity)
    this.section.querySelector('.js-note').value = note
    this.section.querySelector('.js-fulfillment-count').value = fulfillmentCount
  }
}

customElements.define('variant-quantity', VariantQuantity);

class VariantQuantities extends HTMLElement {
  constructor() {
    super();

  }
}

customElements.define('variant-quantities', VariantQuantities);
